var VERSION = 1789874507493

export  {
	VERSION
} 
